import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnInit,
    Renderer2,
    SecurityContext,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { ProtocolIndependentPipe } from '@fi-shared/fi-pipes/protocol-independent.pipe';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { IPreviewImageCellValue } from '@fi-shared/fi-wrapper-table/fi-wrapper-table';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'fi-wrapper-table-preview-image-cell',
    template: `
        @if (isPreviewImageAvailable()) {
          <span #previewImageEl class="CcmListImage"></span>
        }
        
        @if (!isPreviewImageAvailable()) {
          @if (isMatIcon) {
            <mat-icon class="{{ value.iconClass }}" />
          }
          @if (!isMatIcon) {
            <span class="{{ value.iconClass }} CcmList-Icon"></span>
          }
        }
        `,
    styleUrls: ['./fi-wrapper-table-preview-image-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-preview-image-cell' },
    standalone: false,
})
export class FiWrapperTablePreviewImageCellComponent
    extends FiWrapperTableCellBase<IPreviewImageCellValue>
    implements OnInit
{
    previewImageElRef: ElementRef;
    @Input() isMatIcon: boolean;
    @ViewChild('previewImageEl') set previewImageEl(elementRef: ElementRef) {
        if (elementRef) {
            this.previewImageElRef = elementRef;
            this.setBackgroundImageStyle();
        }
    }

    constructor(
        private protocolIndependentPipe: ProtocolIndependentPipe,
        private sanitizer: DomSanitizer,
        private renderer: Renderer2,
    ) {
        super();
    }

    ngOnInit() {
        // this.setBackgroundImageStyle();
    }

    isPreviewImageAvailable(): boolean {
        return !!this.value.image || !!this.value.imageLarge;
    }

    private setBackgroundImageStyle() {
        if (this.isPreviewImageAvailable()) {
            this.renderer.setStyle(this.previewImageElRef.nativeElement, 'backgroundImage', this.getBackgroundImage());
        }
    }

    private getBackgroundImage(): string {
        return this.sanitizer.sanitize(
            SecurityContext.STYLE,
            'url("' + this.protocolIndependentPipe.transform(this.value.image) + '")',
        );
    }
}
